export const selectSampleRanges = (state) => {
    return state.sampleRanges;
}
